package app.login

import app.properties.axiosPost
import app.properties.getTargetValue
import app.settings.backendPath
import kotlinx.html.InputType
import kotlinx.html.id
import kotlinx.html.js.onChangeFunction
import kotlinx.html.js.onClickFunction
import kotlinx.html.js.onKeyDownFunction
import org.w3c.dom.set
import react.*
import react.dom.*
import kotlin.browser.document
import kotlin.browser.localStorage
import kotlin.browser.window

interface LoginStat : RState {
    var login: String?
    var pass: String?
    var error: Boolean
}

class Login : RComponent<RProps, LoginStat>() {

    init {
        state.login = ""
        state.pass = ""
        state.error = false
    }

    fun loginRequest() {
        axiosPost(backendPath + "/login/checkLogin", state).then {
            if(it.data != null && it.data != "") {
                localStorage.set("jwt", it.data.token)
                localStorage.set("type", it.data.type)
                window.location.assign("/dashboard")
            } else {
                localStorage.removeItem("jwt")
                setState {
                    error = true
                }
            }
        }
    }

    override fun RBuilder.render() {
        div("loginBackground") {

        }
        div("loginPage") {
            div ("loginForm") {
                img(src = "/images/logo.png", alt ="Logo" ) {
                    attrs.width = "100%"
                }
                br {  }
                br {  }
                label {
                    +"Մուտքանուն"
                }
                input(classes = "form-control") {
                    attrs {
                        id = "login"
                        onChangeFunction = {
                            val loginValue = getTargetValue(it)
                            setState { login = loginValue }
                        }
                        if(state.error) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                        onKeyDownFunction = {
                            val event: dynamic = it
                            if(event.keyCode == 13) {
                                loginRequest()
                            }
                        }
                    }
                }
                label {
                    +"Գաղտնաբառ"
                }
                input(classes = "form-control", type = InputType.password) {
                    attrs {
                        id = "password"
                        onChangeFunction = {
                            val passwordValue = getTargetValue(it)
                            setState {
                                pass = passwordValue
                            }
                        }
                        onKeyDownFunction = {
                            val event: dynamic = it
                            if(event.keyCode == 13) {
                                loginRequest()
                            }
                        }
                        if(state.error) {
                            jsStyle {
                                border = "1px solid red"
                            }
                        }
                    }
                }
                br {}
                button {
                    attrs.onClickFunction = {
                        loginRequest()
                    }
                    +"Մուտք"
                }
            }
        }
    }
}

fun RBuilder.login() = child(Login::class) {}